import { AppdataContact } from '@cloudageone-schemas/AppdataContact';
import { FilterConfig, FilterType } from 'app/shared/generic-grid/types/grid-filters.types';

export const ContactsFilters: FilterConfig<AppdataContact>[] = [
	{ dataField: 'firstName', label: 'First Name', type: FilterType.TEXTBOX },
	{ dataField: 'lastName', label: 'Last Name', type: FilterType.TEXTBOX },
	{ dataField: 'company', label: 'Company', type: FilterType.TEXTBOX },
	{ dataField: 'email', label: 'Email', type: FilterType.TEXTBOX },
	{ dataField: 'officePhone', label: 'Office Phone', type: FilterType.TEXTBOX },
	{ dataField: 'mobileNumber', label: 'Mobile Number', type: FilterType.TEXTBOX },
	{ dataField: 'address', label: 'Address', type: FilterType.ADDRESS }
];
